import styled from 'styled-components';

const LogoStyle = styled.div`
	--svgHeight: var(--sp5x);

	display: flex;
	align-items: center;
	line-height: 1;
	z-index: 11;

	svg {
		height: var(--svgHeight);

		path {
			fill: var(--lightGray1000);
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--svgHeight: var(--sp4x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--svgHeight: 30px;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--svgHeight: var(--sp3-5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--svgHeight: 26px;
	}
`;

export default LogoStyle;
